import { render, staticRenderFns } from "./NewPaymentMethod.vue?vue&type=template&id=2d18d61e&"
import script from "./NewPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./NewPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports